// Legacy package export for non-esm environments
require('./_interopReexport')(module.exports, require('./lib/_exports/content'))
